export default __webpack_public_path__ + "static/media/CapaLogo.b834122f.svg";